import type { QuotaIncreaseStatus } from "@starsach/shared-types";

/** AWS's request states as words. "Open" ones block a second request: AWS allows one per quota, and a Support case can take days. */
export const QUOTA_REQUEST_STATUS: Record<QuotaIncreaseStatus, { label: string; tone: "ok" | "warning" | "critical" | "neutral"; open: boolean }> = {
  PENDING: { label: "requested", tone: "warning", open: true },
  CASE_OPENED: { label: "case opened", tone: "warning", open: true },
  APPROVED: { label: "approved", tone: "ok", open: false },
  DENIED: { label: "denied", tone: "critical", open: false },
  NOT_APPROVED: { label: "not approved", tone: "critical", open: false },
  CASE_CLOSED: { label: "case closed", tone: "neutral", open: false },
  INVALID_REQUEST: { label: "invalid request", tone: "critical", open: false },
  UNKNOWN: { label: "unknown", tone: "neutral", open: true },
};
